<div class="ml-5">
  <p id="gestion-des-etiquettes" class="titre1 m-4">{{ 'TAGS_MANAGEMENT.TAGS_MANAGEMENT' | translate }}
    <mat-icon
    class="material-symbols-outlined text-[38px] w-[45px] h-[45px] mt-[5px] mr-[30px] float-right">bookmark_added</mat-icon>
  </p>

  <div class="hidden md:block overflow-x-auto">
    @if (isLoading) {
      <div class="flex justify-center items-center h-64">
        <mat-spinner color="accent"></mat-spinner>
      </div>
    }

    @if (!isLoading) {
      @if (!estRootLectureSeule) {
        <div class="flex justify-end mb-4 gap-2">
          <button (click)="openCreateTagDialog()" class="btn-primary-novo">
            {{ 'TAGS_MANAGEMENT.CREATE_TAG' | translate }}
          </button>
          <button [matMenuTriggerFor]="exportMenu" [disabled]="isLoading || !dataSource.filteredData.length"
            class="btn-primary-novo">
            {{ 'TAGS_MANAGEMENT.EXPORT' | translate }}
            <mat-icon>expand_more</mat-icon>
          </button>
          <mat-menu #exportMenu="matMenu" panelClass="export-menu-styling">
            <button mat-menu-item (click)="exporterVersExcel()">
              <mat-icon>table_view</mat-icon>
              <span>{{ 'TAGS_MANAGEMENT.EXPORT_EXCEL' | translate }}</span>
            </button>
            <button mat-menu-item (click)="exporterVersPdf()">
              <mat-icon>picture_as_pdf</mat-icon>
              <span>{{ 'TAGS_MANAGEMENT.EXPORT_PDF' | translate }}</span>
            </button>
          </mat-menu>
        </div>
      }
      <div class="flex items-end justify-end mb-4 gap-3">
        <mat-select [(ngModel)]="selectedEntities" (selectionChange)="applyFilters()" multiple
          placeholder="{{ 'TAGS_MANAGEMENT.ALL_ENTITIES' | translate }}"
          class="w-3/5 h-8 max-w-[300px] border border-gray-300 rounded-md px-3 py-1" panelWidth="300"
          panelHeight="100">
          <mat-option>
            <ngx-mat-select-search [formControl]="entityFilterCtrl"
              [placeholderLabel]="'TAGS_MANAGEMENT.SEARCH' | translate"
              [noEntriesFoundLabel]="'TAGS_MANAGEMENT.NO_RESULTS' | translate">
            </ngx-mat-select-search>
          </mat-option>
          @for (entity of filteredEntities | async; track entity) {
            <mat-option [value]="entity">
              {{entity}}
            </mat-option>
          }
        </mat-select>
        <input type="text" [(ngModel)]="searchTerm" (ngModelChange)="applyFilters()"
          placeholder="{{ 'PACKAGES_PERSO_MANAGEMENT.SEARCH' | translate }}..."
          class="h-8 w-46 rounded-md border-w-2 border-gray-300 shadow-sm focus:border-red-300 focus:ring focus:ring-red-200">
          <button mat-icon-button (click)="resetFilters()" class="h-1/12 w-8 bg-white-200 text-white-600 rounded">
            <mat-icon>restore</mat-icon>
          </button>
        </div>
        <table mat-table [dataSource]="dataSource" matSort class="mat-table-novo">
          <ng-container matColumnDef="nom">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="hidden md:table-cell w-2/5 px-4 py-2"> {{
            'TAGS_MANAGEMENT.NAME' | translate }}</th>
            <td mat-cell *matCellDef="let element" class="hidden md:table-cell w-1/5 px-4 py-2 border-b">
              <span [style.background-color]="element.couleur" [style.color]="obtenirCouleur(element.couleur)"
                class="px-2 py-1 rounded-full text-sm">
                {{etiquetteService.getNomLocalise(element.locales)}}
              </span>
            </td>
          </ng-container>
          <ng-container matColumnDef="entreprise">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="hidden md:table-cell w-2/5 px-4 py-2">{{
            'TAGS_MANAGEMENT.ENTITY' | translate }}</th>
            <td mat-cell *matCellDef="let element" class="hidden md:table-cell w-3/5 px-4 py-2 border-b">
              @for (nomEntite of obtenirNomEntites(element.entiteIds); track nomEntite) {
                <div>
                  {{ nomEntite }}
                </div>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="visibleSurCertificats">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell w-1/10 px-4 py-2">{{
            'TAGS_MANAGEMENT.VISIBLE_ON_CERTIFICATES' | translate }}</th>
            <td mat-cell *matCellDef="let element" class="table-cell w-1/10 px-4 py-2 border-b text-center">
              @if (element.visibleSurCertificats) {
                <mat-icon class="text-center material-symbols-outlined text-green-700"
                >toggle_on</mat-icon>
              } @else {
                <mat-icon
                class="text-center material-symbols-outlined text-red-700">toggle_off</mat-icon>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="nombreUtilisateurs">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell w-1/10 px-4 py-2">{{
            'TAGS_MANAGEMENT.NB_USERS' | translate }}</th>
            <td mat-cell *matCellDef="let element" class="table-cell w-1/10 px-4 py-2 border-b text-center">
              <div class="flex items-center justify-center gap-1 etiquette-count-row">
                <span class="etiquette-count">{{ element.nombreUtilisateurs || 0 }}</span>
                <mat-icon (click)="showUtilisateursEtiquette(element)"
                class="etiquette-eye material-icons-outlined text-black-500 hover:text-red-700 cursor-pointer text-lg">visibility</mat-icon>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="w-1/20 px-2 py-1">{{ 'TAGS_MANAGEMENT.ACTIONS' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="px-2 py-1 text-center">
              <div class="menu-container">
                <button (click)="toggleMenu(element)"
                  class="bg-grey-500 hover:bg-grey-700 font-bold py-2 px-4 border-none hover:text-red-700 transform scale-90 sm:scale-100">
                  <mat-icon class="material-icons-outlined">more_vert</mat-icon>
                </button>
                @if (element.isMenuOpen) {
                  <div
                    class="absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50">
                    @if (!estRootLectureSeule && element.estModifiable) {
                      <div class="py-1" role="menu"
                        aria-orientation="vertical" aria-labelledby="options-menu">
                        <a href="javascript:void(0)"
                          class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 no-underline"
                          role="menuitem" (click)="editTag(element.etiquetteId)" [class.opacity-50]="!element.estModifiable"
                          [class.cursor-not-allowed]="!element.estModifiable"
                          [matTooltip]="!element.estModifiable ? ('TAGS_MANAGEMENT.NOT_MODIFIABLE_TOOLTIP' | translate) : ''">
                          {{ 'TAGS_MANAGEMENT.EDIT' | translate }}
                        </a>
                      </div>
                    }
                    @if (!estRootLectureSeule && element.estModifiable) {
                      <div class="py-1" role="menu"
                        aria-orientation="vertical" aria-labelledby="options-menu">
                        <a href="javascript:void(0)"
                          class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 no-underline"
                          role="menuitem" (click)="deleteTag(element.etiquetteId)" [class.opacity-50]="!element.estModifiable"
                          [class.cursor-not-allowed]="!element.estModifiable"
                          [matTooltip]="!element.estModifiable ? ('TAGS_MANAGEMENT.NOT_MODIFIABLE_TOOLTIP' | translate) : ''">
                          {{ 'TAGS_MANAGEMENT.DELETE' | translate }}
                        </a>
                      </div>
                    }
                  </div>
                }
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let element; columns: displayedColumns;" [ngClass]="{'ligne-gray': !element.estActif}">
          </tr>
        </table>
        @if (dataSource.data.length === 0) {
          <div class="text-center mt-2 text-gray-500">
            {{ 'COMMUN.DATATABLE_AUCUN_RESULTAT' | translate }}
          </div>
        }
        <mat-paginator [pageSizeOptions]="pageSizeOptions" [showFirstLastButtons]="true">
        </mat-paginator>
      }
    </div>

    <div class="md:hidden space-y-4">
      <mat-form-field class="w-full">
        <mat-label>{{ 'TAGS_MANAGEMENT.ALL_ENTITIES' | translate }}</mat-label>
        <mat-select [(ngModel)]="selectedEntities" (selectionChange)="applyFilters()" multiple>
          <mat-option>
            <ngx-mat-select-search [formControl]="entityFilterCtrl"
              [placeholderLabel]="'TAGS_MANAGEMENT.SEARCH' | translate"
              [noEntriesFoundLabel]="'TAGS_MANAGEMENT.NO_RESULTS' | translate">
            </ngx-mat-select-search>
          </mat-option>
          @for (entity of filteredEntities | async; track entity) {
            <mat-option [value]="entity">
              {{entity}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <div class="relative">
        <input type="text" [(ngModel)]="searchTerm" (ngModelChange)="applyFilters()"
          placeholder="{{ 'TAGS_MANAGEMENT.SEARCH' | translate }}..."
          class="w-full px-3 py-2 border rounded-lg text-gray-700 focus:outline-none focus:border-blue-500" />
        </div>

        <div class="flex justify-end mb-4">
          @if (!estRootLectureSeule) {
            <button (click)="openCreateTagDialog()"
              class="w-full bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded">
              {{ 'TAGS_MANAGEMENT.CREATE_TAG' | translate }}
            </button>
          }
        </div>

        @for (tag of dataSource.filteredData; track tag) {
          <div class="bg-white p-4 rounded-lg shadow">
            <div class="flex justify-between items-center">
              <div>
                <span [style.background-color]="tag.couleur" [style.color]="obtenirCouleur(tag.couleur)"
                  class="px-2 py-1 rounded-full text-sm">
                  {{etiquetteService.getNomLocalise(tag.locales)}}
                </span>
              </div>
              <div class="flex space-x-2">
                @if (!estRootLectureSeule) {
                  <button (click)="editTag(tag.etiquetteId)" [disabled]="!tag.estModifiable"
                    class="bg-red-500 hover:bg-red-700 text-white font-bold py-1 px-2 rounded"
                    [ngClass]="{'opacity-50 cursor-not-allowed': !tag.estModifiable}"
                    [matTooltip]="!tag.estModifiable ? ('TAGS_MANAGEMENT.NOT_MODIFIABLE_TOOLTIP' | translate) : ''">
                    <mat-icon>edit</mat-icon>
                  </button>
                }
                @if (!estRootLectureSeule) {
                  <button (click)="deleteTag(tag.etiquetteId)" [disabled]="!tag.estModifiable"
                    class="bg-red-500 hover:bg-red-700 text-white font-bold py-1 px-2 rounded"
                    [ngClass]="{'opacity-50 cursor-not-allowed': !tag.estModifiable}"
                    [matTooltip]="!tag.estModifiable ? ('TAGS_MANAGEMENT.NOT_MODIFIABLE_TOOLTIP' | translate) : ''">
                    <mat-icon>delete</mat-icon>
                  </button>
                }
              </div>
            </div>
            <div class="mt-2">
              <p><strong>{{ 'TAGS_MANAGEMENT.ENTITY' | translate }}:</strong></p>
              <ul class="list-disc pl-5">
                @for (nomEntite of obtenirNomEntites(tag.entiteIds); track nomEntite) {
                  <li>
                    {{ nomEntite }}
                  </li>
                }
              </ul>
            </div>
            <div class="mt-2">
              <p><strong>{{ 'TAGS_MANAGEMENT.VISIBLE_ON_CERTIFICATES' | translate }}:</strong></p>
              @if (tag.visibleSurCertificats) {
                <span class="bg-green-200 text-green-600 py-1 px-3 rounded-full text-xs">
                  {{ 'TAGS_MANAGEMENT.YES' | translate }}
                </span>
              }
              @if (!tag.visibleSurCertificats) {
                <span class="bg-red-200 text-red-600 py-1 px-3 rounded-full text-xs">
                  {{ 'TAGS_MANAGEMENT.NO' | translate }}
                </span>
              }
            </div>
            <div class="mt-2">
              <p class="flex items-center">
                <strong>{{ 'TAGS_MANAGEMENT.NB_USERS' | translate }}:</strong>
                <span class="ml-2 etiquette-count">{{ tag.nombreUtilisateurs || 0 }}</span>
                <mat-icon (click)="showUtilisateursEtiquette(tag)"
                class="ml-2 etiquette-eye material-icons-outlined text-black-500 hover:text-red-700 cursor-pointer">visibility</mat-icon>
              </p>
            </div>
          </div>
        }
      </div>
    </div>